// volto-nick-compat
//
// Reconciles upstream @plone/volto's control-panel UI with nick's deliberate
// REST-API subset (DR-2026-200). Most reconciliation is delivered via component
// customizations (shadows) under src/customizations/ — Volto's addon machinery
// applies those automatically with no JS-side registration.
//
// DR-2026-210: this shared addon also now hosts the fleet-wide editor-toolbar
// Change Password link (relocated from the vilax-only addon), registered on
// appExtras so it renders inside PluggablesProvider on every tenant that loads
// volto-nick-compat (arcab, platetopaper, vilaxnext, future converged tenants).
import ChangePasswordPlug from './components/UserMenuExtras/ChangePasswordPlug';

const applyConfig = (config) => {
  // -- User menu: add Change Password link (DR-2026-091 / DR-2026-210) --
  // Volto's PersonalTools omits Change Password though /change-password works;
  // this Plug on the toolbar-user-menu pluggable adds it. match path '' = all routes.
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    { match: { path: '' }, component: ChangePasswordPlug },
  ];

  return config;
};

export default applyConfig;
